import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsRedirectsStepVisited = new ReduxAsyncAction<
  'UPDATE_IS_REDIRECTS_STEP_VISITED',
  boolean,
  { isRedirectsStepVisited: boolean }
>('UPDATE_IS_REDIRECTS_STEP_VISITED');

UpdateIsRedirectsStepVisited.registerRequest(async (isRedirectsStepVisited: boolean) => {
  return { isRedirectsStepVisited };
});

export const UPDATE_IS_REDIRECTS_STEP_VISITED = UpdateIsRedirectsStepVisited.actionNamespaceConstants;
export const updateIsRedirectsStepVisited = UpdateIsRedirectsStepVisited.request;

export type UpdateIsRedirectsStepVisitedResponseAction = Action<typeof UPDATE_IS_REDIRECTS_STEP_VISITED.response> & {
  data: { isRedirectsStepVisited: boolean };
};
